import {
  ACTION_LOAD_SITE__REQUEST,
  ACTION_LOAD_SITE__SUCCESS,
  ACTION_LOAD_SITE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE__REQUEST:
    case ACTION_LOAD_SITE__SUCCESS:
      return null;

    case ACTION_LOAD_SITE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
